<template>
    <div>
        <b-card>
            <div slot="header">
                <i class="fa fa-list-ul" aria-hidden="true"></i>
                    JSON Web token list
                <div class="card-header-actions">
                    <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
                    <small class="text-muted">docs</small>
                    </a>
                </div>
            </div>
            <b-row>
                <b-col sm="12">
                    <alert-fail :show="'' !== errorMessage"> {{ errorMessage }} </alert-fail>
                    <b-table
                          stacked="sm"
                          :busy="isBusy"
                          :current-page="currentPage"
                          :per-page="numberPerPage"
                          class="table-privilege"
                          tbody-class="tbody" hover
                          thead-tr-class="thead-news"
                          @row-clicked="viewDetails"
                          selectedVariant="single"
                          selectable
                          :fields="fields"
                          :items="list">
                          <template slot="thumbnail" slot-scope="row">
                            <img class="thumbnail" :src="row.item.thumbnail" alt="Thumbnail">
                          </template>
                          <template slot="active" slot-scope="row">
                              <font style="color: #f86c6b" v-if="row.item.active">Inactive</font>
                              <font style="color: #4dbd74" v-else>Active</font>
                          </template>
                            <div slot="table-busy" class="text-center text-dark my-2">
                                <b-spinner variant="dark" class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                    </b-table>
                    <hr/>
                    <b-row>
                        <b-pagination
                        class="pagination my-0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="numberPerPage"
                        ></b-pagination>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import AlertFail from '../../components/alert/AlertFail';
import { dateToStringWithTimeFull } from '../../assets/utils/time';

export default {
  data () {
    return {
      errorMessage: '',
      isBusy: false,
      currentPage: 1,
      numberPerPage: 20,
      fields: [
        { key: 'name' },
        { key: 'type' },
        { key: 'createdDate' },
        { key: 'createdBy' }
      ],
      list: [
        { name: 'messaging-api', createdDate: '10 September 2019, 23:27:48', type: 'secret', createdBy: 'admin' }
      ]

    };
  },
  methods: {
    viewDetails (e) {
      this.$router.push({ name: 'jwt-details', params: { id: e.id } });
    },
    getData () {
      this.isBusy = true;
      this.list = [];
      this.axios.get(process.env.VUE_APP_ACCESS_CONTROL_URL + '/jwt?page=' + this.currentPage)
        .then(response => {
          const data = response.data.data;
          if (data) {
            for (const jwt of data) {
              this.list.push({
                id: jwt.id,
                name: jwt.name,
                type: jwt.type,
                createdBy: jwt.createdBy,
                createdDate: dateToStringWithTimeFull(new Date(jwt.createdAt))
              });
            }
          }
        })
        .catch(error => {
          this.errorMessage = error.response ? error.response.data : error.message;
        })
        .finally(() => {
          this.isBusy = false;
        });
    }
  },
  computed: {
    totalRows () {
      return this.list.length;
    }
  },
  components: {
    AlertFail
  },
  mounted () {
    this.getData();
  }
};
</script>

<style scoped>
  .thumbnail{
        max-width: 100px;
    }
</style>
<style>
    .pagination {
        margin-left: auto;
        margin-right: auto;
    }
</style>
